(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initBrandDirectory = (directory) => {
      if (!directory || directory.dataset.brandDirectoryReady === 'true') {
        return;
      }

      directory.dataset.brandDirectoryReady = 'true';

      const searchInput = directory.querySelector('[data-brand-directory-search]');
      const letterButtons = Array.from(directory.querySelectorAll('[data-brand-directory-letter]'));
      const cards = Array.from(directory.querySelectorAll('[data-brand-card]'));
      const emptyMessage = directory.querySelector('[data-brand-directory-empty]');
      let activeLetter = 'all';

      const normalize = (value) => value.toLowerCase().replace(/\s+/g, ' ').trim();

      const matchesClosestWord = (searchText, query) => {
        if (query.length < 2) {
          return false;
        }

        return query.split(' ').every((queryPart) => {
          if (queryPart.length < 2) {
            return true;
          }

          return searchText.split(/[\s\-&.]+/).some((word) => {
            return word.startsWith(queryPart) || queryPart.startsWith(word);
          });
        });
      };

      const update = () => {
        const query = normalize(searchInput ? searchInput.value : '');
        const matchingCards = cards.filter((card) => {
          const searchText = normalize(card.getAttribute('data-brand-search') || card.textContent || '');
          return query.length === 0 || searchText.includes(query);
        });
        const closestCards = matchingCards.length > 0 ? [] : cards.filter((card) => {
          const searchText = normalize(card.getAttribute('data-brand-search') || card.textContent || '');
          return matchesClosestWord(searchText, query);
        });
        let visibleCount = 0;

        cards.forEach((card) => {
          const searchText = normalize(card.getAttribute('data-brand-search') || card.textContent || '');
          const letter = card.getAttribute('data-brand-letter') || '#';
          const matchesSearch = query.length === 0 || matchingCards.includes(card) || closestCards.includes(card);
          const matchesLetter = query.length > 0 || activeLetter === 'all' || letter === activeLetter;
          const isVisible = matchesSearch && matchesLetter;

          card.hidden = !isVisible;
          if (isVisible) {
            visibleCount += 1;
          }
        });

        if (emptyMessage) {
          emptyMessage.hidden = visibleCount > 0;
        }
      };

      letterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeLetter = button.getAttribute('data-brand-directory-letter') || 'all';
          letterButtons.forEach((item) => item.classList.toggle('is-active', item === button));
          update();
        });
      });

      if (searchInput) {
        searchInput.addEventListener('input', () => {
          activeLetter = 'all';
          letterButtons.forEach((item) => {
            item.classList.toggle('is-active', item.getAttribute('data-brand-directory-letter') === 'all');
          });
          update();
        });
      }

      update();
    };

    const initAllBrandDirectories = () => {
      document.querySelectorAll('.brand-directory').forEach(initBrandDirectory);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllBrandDirectories, { once: true });
    } else {
      initAllBrandDirectories();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initBrandDirectory(event.target.querySelector('.brand-directory'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const minus = event.target.closest('[data-cart-minus]');
    const plus = event.target.closest('[data-cart-plus]');

    if (!minus && !plus) {
      return;
    }

    const quantity = event.target.closest('.cart-item__quantity').querySelector('input');
    const currentValue = Number(quantity.value || 0);

    if (minus) {
      quantity.value = Math.max(0, currentValue - 1);
    }

    if (plus) {
      quantity.value = currentValue + 1;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const madeInUsaPage = document.querySelector('.collection-page--made-usa');
    if (!madeInUsaPage) return;

    const params = new URLSearchParams(window.location.search);
    const hasProductIntent =
      params.get('view') === 'products' ||
      params.has('page') ||
      params.has('sort_by') ||
      Array.from(params.keys()).some((key) => key.startsWith('filter.'));

    madeInUsaPage.classList.toggle('is-product-mode', hasProductIntent);
    madeInUsaPage.classList.toggle('is-landing-mode', !hasProductIntent);
  })();

  document.addEventListener('change', function (event) {
    if (event.target.matches('.collection-sort select')) {
      event.target.form.submit();
    }
  });

  (() => {
    const syncFilterVisibility = (group) => {
      if (!group) return;

      const searchInput = group.querySelector('[data-collection-filter-search]');
      const toggle = group.querySelector('[data-collection-filter-toggle]');
      const values = Array.from(group.querySelectorAll('[data-collection-filter-value]'));
      const query = searchInput ? searchInput.value.trim().toLowerCase() : '';
      const expanded = toggle ? toggle.dataset.expanded === 'true' : true;
      let visibleCount = 0;

      values.forEach((value) => {
        const matchesSearch = !query || (value.dataset.filterText || '').includes(query);
        const shouldCollapse = !expanded && value.classList.contains('is-collapsed') && !query;
        const isHidden = !matchesSearch || shouldCollapse;
        value.hidden = isHidden;
        if (!isHidden) visibleCount += 1;
      });

      if (toggle) {
        toggle.hidden = Boolean(query);
        toggle.textContent = expanded ? 'Show fewer options' : `Show all ${values.length} options`;
      }

      let empty = group.querySelector('[data-collection-filter-empty]');
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'collection-filter__empty';
        empty.dataset.collectionFilterEmpty = '';
        empty.textContent = 'No matching options';
        const valuesWrap = group.querySelector('.collection-filter__values');
        if (valuesWrap) valuesWrap.after(empty);
      }
      empty.hidden = visibleCount > 0;
    };

    document.querySelectorAll('[data-collection-filter-group]').forEach(syncFilterVisibility);

    document.addEventListener('input', (event) => {
      if (event.target.matches('[data-collection-filter-search]')) {
        syncFilterVisibility(event.target.closest('[data-collection-filter-group]'));
      }
    });

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-collection-filter-toggle]');
      if (!toggle) return;

      const isExpanded = toggle.dataset.expanded === 'true';
      toggle.dataset.expanded = isExpanded ? 'false' : 'true';
      syncFilterVisibility(toggle.closest('[data-collection-filter-group]'));
    });
  })();

  (() => {
    const collectionSection = document.querySelector('.collection-page');
    const productGrid = collectionSection ? collectionSection.querySelector('.collection-products') : null;
    const loadMoreWrapper = collectionSection ? collectionSection.querySelector('[data-load-more-wrapper]') : null;
    const loadMoreButton = collectionSection ? collectionSection.querySelector('[data-load-more-button]') : null;
    const loadMoreStatus = collectionSection ? collectionSection.querySelector('[data-load-more-status]') : null;
    const pagination = collectionSection ? collectionSection.querySelector('[data-pagination]') : null;

    if (!productGrid || !loadMoreButton || !loadMoreWrapper) {
      return;
    }

    if (pagination) {
      pagination.classList.add('collection-page__pagination--fallback');
    }

    const parsePageMeta = (url) => {
      try {
        const pageUrl = new URL(url, window.location.origin);
        const pageNumber = Number(pageUrl.searchParams.get('page') || '1');
        return Number.isNaN(pageNumber) ? 1 : pageNumber;
      } catch (error) {
        return 1;
      }
    };

    loadMoreButton.addEventListener('click', async () => {
      const nextUrl = loadMoreButton.dataset.nextUrl;

      if (!nextUrl) {
        return;
      }

      loadMoreButton.disabled = true;
      loadMoreButton.textContent = 'Loading products...';

      try {
        const response = await fetch(nextUrl, {
          headers: {
            Accept: 'text/html'
          }
        });

        if (!response.ok) {
          throw new Error('Unable to load more products');
        }

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = documentFragment.querySelector('.collection-products');
        const nextProducts = nextGrid ? Array.from(nextGrid.querySelectorAll('.collection-product')) : [];
        const nextButton = documentFragment.querySelector('[data-load-more-button]');

        if (nextProducts.length === 0) {
          loadMoreWrapper.hidden = true;
          if (pagination) {
            pagination.classList.remove('collection-page__pagination--fallback');
          }
          return;
        }

        nextProducts.forEach((productCard) => {
          productGrid.appendChild(productCard);
        });

        if (nextButton && nextButton.dataset.nextUrl) {
          loadMoreButton.dataset.nextUrl = nextButton.dataset.nextUrl;
          loadMoreButton.disabled = false;
          loadMoreButton.textContent = 'Load more products';

          if (loadMoreStatus) {
            const nextPage = parsePageMeta(nextUrl);
            loadMoreStatus.textContent = `Loaded page ${nextPage}. More products available.`;
          }
        } else {
          loadMoreWrapper.hidden = true;
        }
      } catch (error) {
        loadMoreButton.disabled = false;
        loadMoreButton.textContent = 'Try loading again';

        if (loadMoreStatus) {
          loadMoreStatus.textContent = 'Products could not be loaded. Use pagination below or try again.';
        }

        if (pagination) {
          pagination.classList.remove('collection-page__pagination--fallback');
        }
      }
    });
  })();

  (() => {
    const updateCardPrice = (card, option) => {
      const price = card.querySelector('[data-card-price]');
      const comparePrice = card.querySelector('[data-card-compare-price]');
      const savings = card.querySelector('[data-card-savings]');

      if (price && option.dataset.variantPrice) {
        price.textContent = option.dataset.variantPrice;
      }

      if (comparePrice) {
        comparePrice.textContent = option.dataset.variantComparePrice || '';
        comparePrice.hidden = !option.dataset.variantComparePrice;
      }

      if (savings) {
        savings.textContent = option.dataset.variantSavings || '';
        savings.hidden = !option.dataset.variantSavings;
      }
    };

    const selectCardVariant = (card, option) => {
      const idInput = card.querySelector('.collection-product__form input[name="id"]');
      const addButton = card.querySelector('.collection-product__form button');
      const quoteButton = card.querySelector('[data-quote-add]');
      const status = card.querySelector('.collection-product__status');
      const isAvailable = option.dataset.variantAvailable === 'true';

      card.querySelectorAll('[data-card-variant]').forEach((item) => {
        item.classList.toggle('is-selected', item === option);
      });

      if (idInput) {
        idInput.value = option.dataset.variantId || idInput.value;
      }

      if (addButton) {
        addButton.disabled = !isAvailable;
        addButton.textContent = isAvailable ? 'Add to cart' : 'Sold out';
      }

      if (quoteButton) {
        quoteButton.dataset.productStoreSku = option.dataset.variantSku || quoteButton.dataset.productStoreSku || '';
        quoteButton.dataset.productUpc = option.dataset.variantUpc || quoteButton.dataset.productUpc || '';
        quoteButton.dataset.productVariantId = option.dataset.variantId || quoteButton.dataset.productVariantId || '';
        quoteButton.dataset.productVariantTitle = option.dataset.variantTitle || quoteButton.dataset.productVariantTitle || '';
      }

      if (status) {
        status.textContent = isAvailable ? 'Ready to ship' : 'Currently unavailable';
      }

      updateCardPrice(card, option);
    };

    document.addEventListener('mouseover', (event) => {
      const option = event.target.closest('[data-card-variant]');

      if (!option) {
        return;
      }

      const card = option.closest('.collection-product');

      if (card) {
        updateCardPrice(card, option);
      }
    });

    document.addEventListener('focusin', (event) => {
      const option = event.target.closest('[data-card-variant]');

      if (!option) {
        return;
      }

      const card = option.closest('.collection-product');

      if (card) {
        updateCardPrice(card, option);
      }
    });

    document.addEventListener('mouseout', (event) => {
      const option = event.target.closest('[data-card-variant]');

      if (!option) {
        return;
      }

      const card = option.closest('.collection-product');
      const selectedOption = card ? card.querySelector('[data-card-variant].is-selected') : null;

      if (card && selectedOption) {
        updateCardPrice(card, selectedOption);
      }
    });

    document.addEventListener('click', (event) => {
      const option = event.target.closest('[data-card-variant]');

      if (!option) {
        return;
      }

      const card = option.closest('.collection-product');

      if (card) {
        selectCardVariant(card, option);
      }
    });
  })();

  (() => {
    const quickCart = document.querySelector('[data-quick-cart]');

    if (!quickCart) {
      return;
    }

    const mediaTarget = quickCart.querySelector('[data-quick-cart-media]');
    const titleTarget = quickCart.querySelector('[data-quick-cart-title]');
    const variantTarget = quickCart.querySelector('[data-quick-cart-variant]');
    const priceTarget = quickCart.querySelector('[data-quick-cart-price]');
    const countTarget = quickCart.querySelector('[data-quick-cart-count]');
    const totalTarget = quickCart.querySelector('[data-quick-cart-total]');
    const closeButtons = quickCart.querySelectorAll('[data-quick-cart-close]');
    let closeTimer;

    const moneyFormatter = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD',
        style: 'currency'
      }).format((cents || 0) / 100);

    const updateHeaderCartCount = (count) => {
      const cartLinks = document.querySelectorAll('a[href="/cart"]');

      cartLinks.forEach((link) => {
        let badge = link.querySelector('sup');

        if (count > 0) {
          if (!badge) {
            badge = document.createElement('sup');
            link.appendChild(badge);
          }

          badge.textContent = count;
          badge.hidden = false;
        } else if (badge) {
          badge.hidden = true;
        }
      });
    };

    const openQuickCart = (item, cart) => {
      window.clearTimeout(closeTimer);

      if (mediaTarget) {
        mediaTarget.innerHTML = item.image ? `<img src="${item.image}" alt="">` : '';
      }

      if (titleTarget) {
        titleTarget.textContent = item.product_title || item.title || 'Product';
      }

      if (variantTarget) {
        variantTarget.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        variantTarget.hidden = !variantTarget.textContent;
      }

      if (priceTarget) {
        priceTarget.textContent = `${item.quantity || 1} x ${moneyFormatter(item.final_price || item.price)}`;
      }

      if (countTarget) {
        countTarget.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in cart`;
      }

      if (totalTarget) {
        totalTarget.textContent = moneyFormatter(cart.total_price);
      }

      quickCart.hidden = false;
      quickCart.classList.add('is-open');
      updateHeaderCartCount(cart.item_count);

      closeTimer = window.setTimeout(() => {
        quickCart.classList.remove('is-open');
        quickCart.hidden = true;
      }, 6500);
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        window.clearTimeout(closeTimer);
        quickCart.classList.remove('is-open');
        quickCart.hidden = true;
      });
    });

    document.addEventListener('submit', async (event) => {
      if (event.defaultPrevented) {
        return;
      }

      const form = event.target.closest('.collection-product__form');

      if (!form) {
        return;
      }

      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const defaultText = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      try {
        const addResponse = await fetch('/cart/add.js', {
          body: new FormData(form),
          headers: {
            Accept: 'application/json'
          },
          method: 'POST'
        });

        if (!addResponse.ok) {
          throw new Error('Unable to add item');
        }

        const item = await addResponse.json();
        const cartResponse = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });
        const cart = await cartResponse.json();

        const cartDrawerEvent = new CustomEvent('dealsclick:cart-drawer-open', {
          detail: {
            cart,
            handled: false,
            notice: 'Product added to your cart.'
          }
        });
        window.dispatchEvent(cartDrawerEvent);

        if (!cartDrawerEvent.detail.handled) {
          openQuickCart(item, cart);
        }

        if (button) {
          button.textContent = 'Added';
          window.setTimeout(() => {
            button.disabled = false;
            button.textContent = defaultText || 'Add to cart';
          }, 1200);
        }
      } catch (error) {
        if (button) {
          button.disabled = false;
          button.textContent = 'Try again';
          window.setTimeout(() => {
            button.textContent = defaultText || 'Add to cart';
          }, 1800);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  const collectionToolbars = document.querySelectorAll('[data-collections-toolbar]');

  collectionToolbars.forEach((toolbar) => {
    const section = toolbar.closest('.collections-page');
    const search = section.querySelector('[data-collections-search]');
    const empty = section.querySelector('[data-collections-empty]');
    const grid = section.querySelector('[data-collections-grid]');
    const loadMoreWrap = section.querySelector('[data-collections-load-more-wrap]');
    const loadMoreButton = section.querySelector('[data-collections-load-more]');
    const loadStatus = section.querySelector('[data-collections-load-status]');
    const pagination = section.querySelector('[data-collections-pagination]');
    const groupButtons = section.querySelectorAll('[data-collections-group-filter]');
    let isAutoFilling = false;
    let isExpandingFilters = false;
    let activeGroup = 'all';
    let expandToken = 0;
    let searchTimer;

    const normalize = (value) => value.toLowerCase().trim();
    const getLoadedCardCount = () => section.querySelectorAll('[data-collection-card]').length;
    const getVisibleCardCount = () => section.querySelectorAll('[data-collection-card]:not([hidden])').length;

    const getCurrentScopeLabel = () => {
      if (activeGroup !== 'all') {
        return activeGroup;
      }

      return 'categories';
    };

    const filterCards = () => {
      const query = normalize(search.value);
      let visibleCount = 0;
      const cards = section.querySelectorAll('[data-collection-card]');

      cards.forEach((card) => {
        const title = normalize(card.dataset.collectionTitle || '');
        const group = card.dataset.collectionGroup || '';
        const groupText = normalize(group);
        const searchableText = `${title} ${groupText}`;
        const matchesQuery = !query || searchableText.includes(query);
        const matchesGroup = activeGroup === 'all' || group === activeGroup;
        const isVisible = matchesQuery && matchesGroup;

        card.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (empty) {
        empty.hidden = visibleCount > 0;
      }

      if (loadStatus) {
        const scopeLabel = getCurrentScopeLabel();

        loadStatus.textContent = query
          ? `${visibleCount} matching ${scopeLabel}`
          : `${visibleCount} ${scopeLabel} loaded`;
      }
    };

    const updateLoadState = (nextUrl, nextStatus, nextPagination) => {
      if (pagination && nextPagination) {
        pagination.innerHTML = nextPagination.innerHTML;
      }

      if (loadStatus && nextStatus) {
        loadStatus.textContent = nextStatus.textContent;
      }

      if (loadMoreButton && nextUrl) {
        loadMoreButton.dataset.nextUrl = nextUrl;
        loadMoreButton.disabled = false;
        loadMoreButton.textContent = loadMoreButton.dataset.originalLabel;
        return;
      }

      if (loadMoreWrap) {
        loadMoreWrap.hidden = true;
      }
    };

    const loadMoreCollections = async () => {
      if (!loadMoreButton || !grid || loadMoreButton.disabled) {
        return false;
      }

      const nextUrl = loadMoreButton.dataset.nextUrl;

      if (!nextUrl) {
        updateLoadState(null);
        return false;
      }

      loadMoreButton.disabled = true;
      loadMoreButton.textContent = 'Loading...';

      try {
        const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });

        if (!response.ok) {
          throw new Error('Could not load collections');
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = doc.querySelector('[data-collections-grid]');
        const nextCards = nextGrid ? nextGrid.querySelectorAll('[data-collection-card]') : [];
        const nextButton = doc.querySelector('[data-collections-load-more]');
        const nextStatus = doc.querySelector('[data-collections-load-status]');
        const nextPagination = doc.querySelector('[data-collections-pagination]');

        nextCards.forEach((card) => {
          grid.append(card);
        });

        updateLoadState(nextButton ? nextButton.dataset.nextUrl : null, nextStatus, nextPagination);
        filterCards();
        return true;
      } catch (error) {
        loadMoreButton.disabled = false;
        loadMoreButton.textContent = 'Try again';
        return false;
      }
    };

    const expandFilteredResults = async () => {
      if (!loadMoreButton || isAutoFilling || isExpandingFilters) {
        return;
      }

      const token = expandToken;
      const needsExpandedSearch = normalize(search.value) || activeGroup !== 'all';

      if (!needsExpandedSearch) {
        return;
      }

      isExpandingFilters = true;

      try {
        let attempts = 0;

        while (loadMoreButton.dataset.nextUrl && attempts < 40) {
          if (token !== expandToken) {
            break;
          }

          if (getVisibleCardCount() >= 18) {
            break;
          }

          const didLoad = await loadMoreCollections();

          if (!didLoad) {
            break;
          }

          attempts += 1;
        }
      } finally {
        isExpandingFilters = false;
      }
    };

    const scheduleFilteredExpansion = () => {
      window.clearTimeout(searchTimer);
      expandToken += 1;
      filterCards();

      searchTimer = window.setTimeout(() => {
        expandFilteredResults();
      }, 180);
    };

    search.addEventListener('input', scheduleFilteredExpansion);

    groupButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeGroup = button.dataset.collectionsGroupFilter || 'all';

        groupButtons.forEach((currentButton) => {
          currentButton.classList.toggle('is-active', currentButton === button);
        });

        scheduleFilteredExpansion();
      });
    });

    const fillCollections = async (options = {}) => {
      if (!loadMoreButton || isAutoFilling || isExpandingFilters || normalize(search.value) || activeGroup !== 'all') {
        return;
      }

      const minimumCount = options.minimumCount || 24;
      const requireIncrease = Boolean(options.requireIncrease);
      const maxAttempts = options.maxAttempts || 40;
      const initialCount = getLoadedCardCount();
      isAutoFilling = true;

      try {
        let attempts = 0;

        while (loadMoreButton.dataset.nextUrl && attempts < maxAttempts) {
          const loadedCount = getLoadedCardCount();
          const hasNewCards = loadedCount > initialCount;
          const shouldKeepLoading = requireIncrease ? !hasNewCards : loadedCount < minimumCount;

          if (!shouldKeepLoading) {
            break;
          }

          const didLoad = await loadMoreCollections();

          if (!didLoad) {
            break;
          }

          attempts += 1;
        }
      } finally {
        isAutoFilling = false;
      }
    };

    const autoFillCollections = () => fillCollections({ minimumCount: 24, maxAttempts: 40 });
    const loadNextVisibleBatch = () => fillCollections({ requireIncrease: true, maxAttempts: 40 });
    const primeCollectionsPage = () => {
      autoFillCollections();
      window.setTimeout(autoFillCollections, 350);
      window.setTimeout(autoFillCollections, 1200);
    };

    if (loadMoreButton) {
      loadMoreButton.dataset.originalLabel = loadMoreButton.textContent.trim();
      loadMoreButton.addEventListener('click', loadNextVisibleBatch);

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && !normalize(search.value)) {
                loadNextVisibleBatch();
              }
            });
          },
          { rootMargin: '500px 0px' }
        );

        observer.observe(loadMoreButton);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', primeCollectionsPage, { once: true });
      } else {
        primeCollectionsPage();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["continue-browsing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-continue-browsing]');

    if (sections.length === 0) {
      return;
    }

    const storageKey = 'dealsclick:recently-viewed';
    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    let recentProducts = [];

    try {
      recentProducts = JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (error) {
      recentProducts = [];
    }

    const validProducts = recentProducts.filter((item) => item && item.url && item.title);

    if (validProducts.length === 0) {
      return;
    }

    sections.forEach((section) => {
      const limit = Number(section.dataset.limit || 8);
      const products = validProducts.slice(0, limit);
      const rail = section.querySelector('[data-continue-products]');
      const categorySlot = section.querySelector('[data-continue-category-card]');
      const context = section.querySelector('[data-continue-context]');
      const typeTarget = section.querySelector('[data-continue-type]');
      const categoriesTarget = section.querySelector('[data-continue-categories]');
      const lastProduct = products[0];

      if (!rail || products.length === 0) {
        return;
      }

      const categoryMap = new Map();

      validProducts.forEach((item) => {
        if (!Array.isArray(item.collections)) {
          return;
        }

        item.collections.forEach((collection) => {
          if (!collection || !collection.title || !collection.url || categoryMap.has(collection.url)) {
            return;
          }

          categoryMap.set(collection.url, collection);
        });
      });

      const relatedCategories = Array.from(categoryMap.values()).slice(0, 6);
      const categoryCardMarkup = relatedCategories.length > 0
        ? `
          <article class="continue-card continue-card--categories">
            <div class="continue-card__category-head">
              <span aria-hidden="true">+</span>
              <p>Explore categories</p>
              <h3>${lastProduct && lastProduct.type ? `More in ${escapeHtml(lastProduct.type)}` : 'Related to your browsing'}</h3>
            </div>
            <div class="continue-card__category-links">
              ${relatedCategories
                .map((collection) => `<a href="${escapeHtml(collection.url)}">${escapeHtml(collection.title)}</a>`)
                .join('')}
            </div>
          </article>
        `
        : '';

      rail.innerHTML = products
        .map((item) => {
          const imageMarkup = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
            : '<span class="continue-card__placeholder" aria-hidden="true"></span>';
          const typeMarkup = item.type ? `<span class="continue-card__type">${escapeHtml(item.type)}</span>` : '';

          return `
            <article class="continue-card">
              <a class="continue-card__media" href="${escapeHtml(item.url)}">
                ${imageMarkup}
              </a>
              <div class="continue-card__body">
                ${item.brand ? `<p class="continue-card__brand">${escapeHtml(item.brand)}</p>` : ''}
                <h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h3>
                <div class="continue-card__meta">
                  ${typeMarkup}
                  ${item.price ? `<strong>${escapeHtml(item.price)}</strong>` : ''}
                </div>
              </div>
            </article>
          `;
        })
        .join('');

      if (categorySlot) {
        categorySlot.innerHTML = categoryCardMarkup;
        categorySlot.hidden = categoryCardMarkup === '';
      }

      if (context && lastProduct) {
        let hasContext = false;

        if (typeTarget && lastProduct.type) {
          typeTarget.innerHTML = `Based on <strong>${escapeHtml(lastProduct.type)}</strong>`;
          hasContext = true;
        }

        if (categoriesTarget && Array.isArray(lastProduct.collections)) {
          const categoryLinks = lastProduct.collections
            .filter((collection) => collection && collection.title && collection.url)
            .slice(0, 4);

          if (categoryLinks.length > 0) {
            categoriesTarget.innerHTML = categoryLinks
              .map((collection) => `<a href="${escapeHtml(collection.url)}">${escapeHtml(collection.title)}</a>`)
              .join('');
            hasContext = true;
          }
        }

        context.hidden = !hasContext;
      }

      section.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-page"] && !Shopify.designMode) return;
  try {
    
  const slugifyPageHeading = (text) =>
    text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 48);

  document.querySelectorAll('[data-custom-page-content]').forEach((content) => {
    const body = content.closest('.custom-page__body');
    const toc = body ? body.querySelector('[data-custom-page-toc]') : null;
    const nav = toc ? toc.querySelector('nav') : null;
    const headings = Array.from(content.querySelectorAll('h2')).slice(0, 12);

    if (!toc || !nav || headings.length < 2) {
      return;
    }

    headings.forEach((heading, index) => {
      if (!heading.id) {
        const baseId = slugifyPageHeading(heading.textContent || `section-${index + 1}`);
        heading.id = baseId || `section-${index + 1}`;
      }

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      nav.append(link);
    });

    toc.hidden = false;
  });

  document.querySelectorAll('[data-help-search-wrap]').forEach((wrap) => {
    const section = wrap.closest('.custom-page');
    const input = wrap.querySelector('[data-help-search]');
    const count = wrap.querySelector('[data-help-search-count]');
    const items = Array.from(section.querySelectorAll('[data-help-search-item]'));
    const groups = Array.from(section.querySelectorAll('[data-help-search-group]'));

    if (!input || items.length === 0) {
      return;
    }

    const getSearchText = (item) =>
      `${item.textContent || ''} ${item.dataset.helpSearchCategory || ''}`.toLowerCase();

    const updateResults = () => {
      const terms = input.value
        .toLowerCase()
        .split(/\s+/)
        .map((term) => term.trim())
        .filter(Boolean);

      let visibleCount = 0;

      items.forEach((item) => {
        const isVisible = terms.length === 0 || terms.every((term) => getSearchText(item).includes(term));
        item.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      groups.forEach((group) => {
        const visibleChildren = group.querySelectorAll('[data-help-search-item]:not([hidden])');
        group.toggleAttribute('data-help-search-empty', visibleChildren.length === 0);
      });

      if (count) {
        count.textContent =
          terms.length === 0
            ? 'Search by keyword, topic, or page name.'
            : `${visibleCount} matching ${visibleCount === 1 ? 'result' : 'results'}`;
      }
    };

    input.addEventListener('input', updateResults);
    updateResults();
  });

  document.addEventListener('click', (event) => {
    const backLink = event.target.closest('[data-custom-page-back]');

    if (!backLink) {
      return;
    }

    if (window.history.length > 1 && document.referrer) {
      const previousUrl = new URL(document.referrer);

      if (previousUrl.hostname === window.location.hostname) {
        event.preventDefault();
        window.history.back();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deals-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (slider) => {
      if (!slider || slider.dataset.dealsHeroReady === 'true') return;

      const track = slider.querySelector('[data-deals-hero-track]');
      const slides = Array.from(slider.querySelectorAll('[data-deals-hero-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-deals-hero-dot]'));
      const previousButton = slider.querySelector('[data-deals-hero-prev]');
      const nextButton = slider.querySelector('[data-deals-hero-next]');

      if (!track || slides.length === 0) return;

      slider.dataset.dealsHeroReady = 'true';
      let activeIndex = 0;
      let autoTimer = null;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const setActive = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        dots.forEach((dot, dotIndex) => {
          if (dotIndex === activeIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const goTo = (index) => {
        const nextIndex = (index + slides.length) % slides.length;
        const left = slides[nextIndex].offsetLeft;
        track.scrollTo({ left, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
        setActive(nextIndex);
      };

      const stopAuto = () => {
        if (autoTimer) window.clearInterval(autoTimer);
        autoTimer = null;
      };

      const startAuto = () => {
        stopAuto();
        if (prefersReducedMotion || slides.length < 2) return;
        autoTimer = window.setInterval(() => goTo(activeIndex + 1), 6500);
      };

      previousButton?.addEventListener('click', () => {
        stopAuto();
        goTo(activeIndex - 1);
      });

      nextButton?.addEventListener('click', () => {
        stopAuto();
        goTo(activeIndex + 1);
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          stopAuto();
          goTo(index);
        });
      });

      track.addEventListener('scroll', () => {
        const width = track.clientWidth || 1;
        setActive(Math.round(track.scrollLeft / width));
      }, { passive: true });

      slider.addEventListener('mouseenter', stopAuto);
      slider.addEventListener('focusin', stopAuto);
      slider.addEventListener('mouseleave', startAuto);
      slider.addEventListener('focusout', startAuto);

      setActive(0);
      startAuto();
    };

    const initAll = () => {
      document.querySelectorAll('[data-deals-hero-slider]').forEach(initSlider);
    };

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-explore-tab]');
    if (!tab) return;

    const section = tab.closest('.explore-products');
    const targetId = tab.dataset.exploreTarget;
    const target = document.getElementById(targetId);
    if (!section || !target) return;

    section.querySelectorAll('[data-explore-tab]').forEach((button) => {
      const isActive = button === tab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    section.querySelectorAll('.explore-products__panel').forEach((panel) => {
      const isActive = panel === target;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const accountMenus = document.querySelectorAll('[data-account-menu]');
    const liveMenus = document.querySelectorAll('[data-live-menu]');
    const flyoutMenus = document.querySelectorAll('[data-flyout-shop]');
    const headerWraps = document.querySelectorAll('.site-header-wrap--sticky');

    if (headerWraps.length) {
      let scrollTicking = false;
      const updateHeaderScrollState = () => {
        headerWraps.forEach((headerWrap) => {
          headerWrap.classList.toggle('site-header-wrap--is-scrolled', window.scrollY > 12);
        });
        scrollTicking = false;
      };

      updateHeaderScrollState();
      window.addEventListener(
        'scroll',
        () => {
          if (scrollTicking) {
            return;
          }

          scrollTicking = true;
          window.requestAnimationFrame(updateHeaderScrollState);
        },
        { passive: true }
      );
    }

    accountMenus.forEach((accountMenu) => {
      accountMenu.addEventListener('toggle', () => {
        if (!accountMenu.open) {
          return;
        }

        accountMenus.forEach((otherMenu) => {
          if (otherMenu !== accountMenu) {
            otherMenu.open = false;
          }
        });
      });
    });

    liveMenus.forEach((liveMenu) => {
      liveMenu.addEventListener('toggle', () => {
        if (!liveMenu.open) {
          return;
        }

        liveMenus.forEach((otherMenu) => {
          if (otherMenu !== liveMenu) {
            otherMenu.open = false;
          }
        });
      });
    });

    document.addEventListener('click', (event) => {
      accountMenus.forEach((accountMenu) => {
        if (accountMenu.open && !accountMenu.contains(event.target)) {
          accountMenu.open = false;
        }
      });

      liveMenus.forEach((liveMenu) => {
        if (liveMenu.open && !liveMenu.contains(event.target)) {
          liveMenu.open = false;
        }
      });

      flyoutMenus.forEach((flyoutMenu) => {
        if (flyoutMenu.open && !flyoutMenu.contains(event.target)) {
          flyoutMenu.open = false;
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') {
        return;
      }

      flyoutMenus.forEach((flyoutMenu) => {
        flyoutMenu.open = false;
      });
    });

    flyoutMenus.forEach((flyoutMenu) => {
      const parentTriggers = Array.from(flyoutMenu.querySelectorAll('[data-flyout-parent-trigger]'));
      const parentPanels = Array.from(flyoutMenu.querySelectorAll('[data-flyout-parent-panel]'));
      const departmentsTrack = flyoutMenu.querySelector('.site-header__flyout-departments');
      const parentsColumn = flyoutMenu.querySelector('.site-header__flyout-column--parents');
      const childrenColumn = flyoutMenu.querySelector('.site-header__flyout-column--children');
      const backButtons = Array.from(flyoutMenu.querySelectorAll('[data-flyout-back]'));
      const closeButtons = Array.from(flyoutMenu.querySelectorAll('[data-flyout-close]'));
      const filterInputs = Array.from(flyoutMenu.querySelectorAll('[data-flyout-filter]'));
      const resultsLimit = 48;
      const isMobileFlyout = () => window.matchMedia('(max-width: 1024px)').matches;
      const normalizeFilterValue = (value) => value.toLowerCase().replace(/\s+/g, ' ').trim();
      const scrollMobileColumnIntoView = (column) => {
        if (!isMobileFlyout() || !column || !departmentsTrack) {
          return;
        }

        column.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      };

      const getFlyoutPanelData = (panel) => {
        if (panel.flyoutResultsData) {
          return panel.flyoutResultsData;
        }

        const dataScript = panel.querySelector('[data-flyout-results-data]');
        if (!dataScript) {
          panel.flyoutResultsData = [];
          return panel.flyoutResultsData;
        }

        try {
          panel.flyoutResultsData = JSON.parse(dataScript.textContent || '[]');
        } catch (error) {
          panel.flyoutResultsData = [];
        }

        return panel.flyoutResultsData;
      };

      const renderFlyoutPanel = (panel, visibleLimit = resultsLimit) => {
        if (!panel) {
          return;
        }

        const input = panel.querySelector('[data-flyout-filter]');
        const resultsList = panel.querySelector('[data-flyout-results]');
        const showMoreButton = panel.querySelector('[data-flyout-show-more]');
        const emptyMessage = panel.querySelector('[data-flyout-filter-empty]');
        if (!resultsList) {
          return;
        }

        const query = input ? normalizeFilterValue(input.value) : '';
        const data = getFlyoutPanelData(panel);
        const matches = data.filter((item) => {
          const text = normalizeFilterValue(`${item.group || ''} ${item.title || ''}`);
          return query === '' || text.includes(query);
        });
        const renderedMatches = matches.slice(0, visibleLimit);

        resultsList.replaceChildren();
        renderedMatches.forEach((item) => {
          const listItem = document.createElement('li');
          const link = document.createElement('a');
          const textWrap = document.createElement('span');

          link.className = item.group ? 'site-header__flyout-link site-header__flyout-link--nested' : 'site-header__flyout-link';
          link.href = item.url;

          if (item.group) {
            const group = document.createElement('small');
            group.textContent = item.group;
            textWrap.append(group);
          }

          textWrap.append(document.createTextNode(item.title));
          link.append(textWrap);
          listItem.append(link);
          resultsList.append(listItem);
        });

        if (emptyMessage) {
          emptyMessage.hidden = matches.length !== 0;
        }

        if (showMoreButton) {
          const remainingMatches = Math.max(matches.length - visibleLimit, 0);
          showMoreButton.hidden = remainingMatches === 0;
          showMoreButton.textContent = `Show all categories (${remainingMatches} more)`;
          showMoreButton.dataset.totalMatches = matches.length;
          showMoreButton.dataset.visibleLimit = visibleLimit;
        }
      };

      const filterFlyoutPanel = (input) => {
        renderFlyoutPanel(input.closest('[data-flyout-parent-panel]'), resultsLimit);
      };

      const activateParentPanel = (targetId) => {
        parentTriggers.forEach((trigger) => {
          const isActive = trigger.getAttribute('data-flyout-target') === targetId;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        parentPanels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            renderFlyoutPanel(panel);
          }
        });
      };

      parentTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          activateParentPanel(trigger.getAttribute('data-flyout-target'));
          scrollMobileColumnIntoView(childrenColumn);
        });
      });

      filterInputs.forEach((input) => {
        input.addEventListener('input', () => {
          filterFlyoutPanel(input);
        });

        input.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || input.value === '') {
            return;
          }

          event.stopPropagation();
          input.value = '';
          filterFlyoutPanel(input);
        });
      });

      parentPanels.forEach((panel) => {
        const showMoreButton = panel.querySelector('[data-flyout-show-more]');
        if (!showMoreButton) {
          return;
        }

        showMoreButton.addEventListener('click', () => {
          const totalMatches = Number(showMoreButton.dataset.totalMatches || getFlyoutPanelData(panel).length);
          renderFlyoutPanel(panel, totalMatches);
        });
      });

      backButtons.forEach((button) => {
        button.addEventListener('click', () => {
          scrollMobileColumnIntoView(parentsColumn);
        });
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', () => {
          flyoutMenu.open = false;
        });
      });

      flyoutMenu.addEventListener('toggle', () => {
        if (!flyoutMenu.open || parentTriggers.length === 0) {
          return;
        }

        const activeParent = parentTriggers.find((trigger) => trigger.classList.contains('is-active')) || parentTriggers[0];
        activateParentPanel(activeParent.getAttribute('data-flyout-target'));
        if (departmentsTrack) {
          departmentsTrack.scrollTo({ left: 0, behavior: 'auto' });
        }
      });
    });

    const departmentPanels = document.querySelectorAll('.site-header__department-panel');

    departmentPanels.forEach((panel) => {
      const searchInput = panel.querySelector('[data-department-search]');
      const departmentItems = Array.from(panel.querySelectorAll('[data-department-item]'));
      const emptyMessage = panel.querySelector('[data-department-empty]');

      if (!searchInput || departmentItems.length === 0) {
        return;
      }

      const normalize = (value) => value.toLowerCase().replace(/\s+/g, ' ').trim();

      const setActiveDepartment = (activeItem) => {
        departmentItems.forEach((item) => {
          item.classList.toggle('is-active', item === activeItem);
        });
      };

      const findDepartmentByTitle = (title) => {
        const normalizedTitle = normalize(title || '');
        return departmentItems.find((item) => normalize(item.getAttribute('data-department-text') || '') === normalizedTitle);
      };

      const setFirstVisibleDepartmentActive = () => {
        const activeItem = departmentItems.find((item) => !item.hidden);
        setActiveDepartment(activeItem || null);
      };

      const updateDepartmentSearch = () => {
        const query = normalize(searchInput.value);
        let visibleDepartmentCount = 0;

        panel.classList.toggle('is-searching', query.length > 0);

        departmentItems.forEach((item) => {
          const departmentLink = item.querySelector('.site-header__department-link');
          const resultLinks = Array.from(item.querySelectorAll('[data-department-result]'));
          const itemText = normalize(item.textContent || '');
          const departmentText = normalize(item.getAttribute('data-department-text') || '');
          const departmentMatches = query.length > 0 && departmentText.includes(query);
          let visibleResultCount = 0;

          resultLinks.forEach((link) => {
            const linkMatches = normalize(link.textContent || '').includes(query);
            const showLink = query.length === 0 || departmentMatches || linkMatches;
            link.hidden = !showLink;

            if (showLink) {
              visibleResultCount += 1;
            }
          });

          const showDepartment = query.length === 0 || departmentMatches || itemText.includes(query) || visibleResultCount > 0;
          item.hidden = !showDepartment;

          if (departmentLink) {
            departmentLink.hidden = !showDepartment;
          }

          if (showDepartment) {
            visibleDepartmentCount += 1;
          }
        });

        if (emptyMessage) {
          emptyMessage.hidden = query.length === 0 || visibleDepartmentCount > 0;
        }

        if (query.length > 0) {
          setFirstVisibleDepartmentActive();
        }
      };

      panel.addEventListener('pointerover', (event) => {
        const activeItem = event.target.closest('[data-department-item]');

        if (activeItem && panel.contains(activeItem)) {
          setActiveDepartment(activeItem);
        }
      });

      panel.addEventListener('focusin', (event) => {
        const activeItem = event.target.closest('[data-department-item]');

        if (activeItem && panel.contains(activeItem)) {
          setActiveDepartment(activeItem);
        }
      });

      panel.addEventListener('click', (event) => {
        const departmentLink = event.target.closest('.site-header__department-link');

        if (!departmentLink || !panel.contains(departmentLink)) {
          return;
        }

        if (!window.matchMedia('(max-width: 720px)').matches) {
          return;
        }

        const activeItem = departmentLink.closest('[data-department-item]');

        if (!activeItem || !activeItem.querySelector('.site-header__submenu')) {
          return;
        }

        if (!activeItem.classList.contains('is-active')) {
          event.preventDefault();
          setActiveDepartment(activeItem);
        }
      });

      searchInput.addEventListener('input', updateDepartmentSearch);

      const details = panel.closest('details');
      if (details) {
        const header = details.closest('.site-header');
        const railLinks = header ? Array.from(header.querySelectorAll('[data-category-rail-link]')) : [];
        const categoryMenuTrigger = header ? header.querySelector('[data-category-menu-trigger]') : null;
        const categoryRail = header ? header.querySelector('.site-header__category-rail') : null;

        const closeDepartmentMenu = () => {
          if (details.open) {
            details.open = false;
          }
          details.classList.remove('is-rail-open');
          if (categoryRail) {
            categoryRail.classList.remove('is-expanded');
          }
        };

        const summary = details.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', () => {
            details.classList.remove('is-rail-open');
          });
        }

        document.addEventListener('pointerdown', (event) => {
          const clickedRail = railLinks.some((railLink) => railLink.contains(event.target));
          const clickedCategoryMenuTrigger = categoryMenuTrigger && categoryMenuTrigger.contains(event.target);

          if (details.open && !details.contains(event.target) && !clickedRail && !clickedCategoryMenuTrigger) {
            closeDepartmentMenu();
          }
        });

        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closeDepartmentMenu();
          }
        });

        details.addEventListener('toggle', () => {
          if (details.open) {
            if (!details.classList.contains('is-rail-open')) {
              setFirstVisibleDepartmentActive();
            }
          }

          if (!details.open) {
            details.classList.remove('is-rail-open');
            searchInput.value = '';
            updateDepartmentSearch();
          }
        });
      }
    });

    document.querySelectorAll('.site-header').forEach((header) => {
      const railLinks = Array.from(header.querySelectorAll('[data-category-rail-link]'));
      const categoryMenuTrigger = header.querySelector('[data-category-menu-trigger]');
      const railPanels = header.querySelector('[data-category-rail-panels]');
      const panelItems = railPanels ? Array.from(railPanels.querySelectorAll('[data-category-rail-panel]')) : [];
      const closeButtons = railPanels ? Array.from(railPanels.querySelectorAll('[data-category-rail-close]')) : [];
      const departments = header.querySelector('.site-header__departments');
      const categoryRail = header.querySelector('.site-header__category-rail');
      const brandPanel = header.querySelector('[data-brand-menu]');
      const brandMenuTriggers = Array.from(header.querySelectorAll('[data-brand-menu-trigger]'));
      const brandMenuClose = brandPanel ? brandPanel.querySelector('[data-brand-menu-close]') : null;
      const brandSearchInput = brandPanel ? brandPanel.querySelector('[data-brand-search-input]') : null;
      const brandLinks = brandPanel ? Array.from(brandPanel.querySelectorAll('[data-brand-link]')) : [];
      const brandEmpty = brandPanel ? brandPanel.querySelector('[data-brand-empty]') : null;

      if (!brandPanel && (!railPanels || railLinks.length === 0 || panelItems.length === 0)) {
        return;
      }

      const setRailExpanded = (isExpanded) => {
        if (categoryRail) {
          categoryRail.classList.toggle('is-expanded', isExpanded);
        }
      };

      const closeRailPanels = () => {
        if (!railPanels) {
          return;
        }

        railPanels.classList.remove('is-open');
        railLinks.forEach((link) => link.classList.remove('is-active'));
        panelItems.forEach((panel) => panel.classList.remove('is-active'));
        if (!departments || !departments.open) {
          setRailExpanded(false);
        }
      };

      const updateBrandSearch = () => {
        if (!brandSearchInput || brandLinks.length === 0) {
          return;
        }

        const query = brandSearchInput.value.toLowerCase().replace(/\s+/g, ' ').trim();
        let visibleCount = 0;

        brandLinks.forEach((link) => {
          const text = (link.getAttribute('data-brand-search') || link.textContent || '').toLowerCase().replace(/\s+/g, ' ').trim();
          const isVisible = query.length === 0 || text.includes(query);
          link.hidden = !isVisible;
          link.classList.toggle('is-filtered', !isVisible);
          if (isVisible) {
            visibleCount += 1;
          }
        });

        if (brandEmpty) {
          brandEmpty.hidden = visibleCount > 0;
        }
      };

      const closeBrandMenu = () => {
        if (!brandPanel) {
          return;
        }

        brandPanel.classList.remove('is-open');
        brandPanel.hidden = true;
        brandMenuTriggers.forEach((trigger) => trigger.classList.remove('is-active'));
      };

      const openBrandMenu = () => {
        if (!brandPanel) {
          return;
        }

        closeRailPanels();
        if (departments) {
          departments.open = false;
          departments.classList.remove('is-rail-open');
        }
        setRailExpanded(false);
        brandPanel.hidden = false;
        brandPanel.classList.add('is-open');
        brandMenuTriggers.forEach((trigger) => trigger.classList.add('is-active'));
        updateBrandSearch();
        if (brandSearchInput && window.matchMedia('(min-width: 721px)').matches) {
          brandSearchInput.focus();
        }
      };

      const toggleBrandMenu = () => {
        if (!brandPanel) {
          return;
        }

        if (brandPanel.classList.contains('is-open')) {
          closeBrandMenu();
          return;
        }

        openBrandMenu();
      };

      const syncCategoryMenuTrigger = () => {
        if (categoryMenuTrigger && departments) {
          categoryMenuTrigger.classList.toggle('is-active', departments.open);
        }
      };

      const openRailPanel = (railLink, event) => {
        if (!railPanels) {
          return;
        }

        const targetId = railLink.getAttribute('data-category-panel');
        const activePanel = targetId ? railPanels.querySelector(`#${CSS.escape(targetId)}`) : null;

        if (!activePanel) {
          return;
        }

        event.preventDefault();

        if (railPanels.classList.contains('is-open') && railLink.classList.contains('is-active')) {
          closeRailPanels();
          return;
        }

        if (departments) {
          departments.open = false;
          departments.classList.remove('is-rail-open');
        }

        closeBrandMenu();
        setRailExpanded(true);
        railPanels.classList.add('is-open');
        railLinks.forEach((link) => link.classList.toggle('is-active', link === railLink));
        panelItems.forEach((panel) => panel.classList.toggle('is-active', panel === activePanel));
      };

      railLinks.forEach((railLink) => {
        railLink.addEventListener('click', (event) => openRailPanel(railLink, event));
      });

      closeButtons.forEach((button) => {
        button.addEventListener('click', closeRailPanels);
      });

      brandMenuTriggers.forEach((trigger) => {
        trigger.addEventListener('click', toggleBrandMenu);
      });

      if (brandMenuClose) {
        brandMenuClose.addEventListener('click', closeBrandMenu);
      }

      if (brandSearchInput) {
        brandSearchInput.addEventListener('input', updateBrandSearch);
      }

      if (brandPanel) {
        brandPanel.addEventListener('pointerdown', (event) => {
          event.stopPropagation();
        });
      }

      if (categoryMenuTrigger && departments) {
        categoryMenuTrigger.addEventListener('click', () => {
          closeRailPanels();
          closeBrandMenu();
          departments.open = !departments.open;
          departments.classList.remove('is-rail-open');
          setRailExpanded(departments.open);
          syncCategoryMenuTrigger();
        });

        departments.addEventListener('toggle', () => {
          syncCategoryMenuTrigger();
          setRailExpanded(departments.open || Boolean(railPanels && railPanels.classList.contains('is-open')));
        });
      }

      header.addEventListener('pointerleave', () => {
        closeRailPanels();
      });

      document.addEventListener('pointerdown', (event) => {
        if (railPanels && railPanels.classList.contains('is-open')) {
          if (!railPanels.contains(event.target) && !railLinks.some((link) => link.contains(event.target))) {
            closeRailPanels();
          }
        }

        if (brandPanel && brandPanel.classList.contains('is-open')) {
          const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
          const clickedBrandTrigger = brandMenuTriggers.some((trigger) => trigger.contains(event.target));
          const clickedBrandPanel = brandPanel.contains(event.target) || eventPath.includes(brandPanel);

          if (!clickedBrandPanel && !clickedBrandTrigger) {
            closeBrandMenu();
          }
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeRailPanels();
          closeBrandMenu();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const gallery = document.querySelector('.product-page__gallery');

    if (!gallery) {
      return;
    }

    const mainImage = gallery.querySelector('.product-page__zoom-trigger img');
    const zoomImage = document.querySelector('.product-page__zoom-image');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

    if (!mainImage || thumbs.length === 0) {
      return;
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const mainSrc = thumb.dataset.mainImage;
        const zoomSrc = thumb.dataset.zoomImage || mainSrc;
        const alt = thumb.dataset.imageAlt || mainImage.alt || '';

        if (mainSrc) {
          mainImage.src = mainSrc;
          mainImage.removeAttribute('srcset');
        }

        mainImage.alt = alt;

        if (zoomImage && zoomSrc) {
          zoomImage.src = zoomSrc;
          zoomImage.removeAttribute('srcset');
          zoomImage.alt = alt;
        }

        thumbs.forEach((item) => {
          item.classList.toggle('is-active', item === thumb);
          item.setAttribute('aria-current', item === thumb ? 'true' : 'false');
        });
      });
    });
  })();

  (() => {
    const zoomModal = document.querySelector('[data-product-zoom-modal]');
    const zoomOpen = document.querySelector('[data-product-zoom-open]');

    if (!zoomModal || !zoomOpen) {
      return;
    }

    const closeButtons = zoomModal.querySelectorAll('[data-product-zoom-close]');
    const closeZoom = () => {
      zoomModal.hidden = true;
      document.documentElement.classList.remove('product-zoom-open');
      zoomOpen.focus();
    };

    zoomOpen.addEventListener('click', () => {
      zoomModal.hidden = false;
      document.documentElement.classList.add('product-zoom-open');
      const closeButton = zoomModal.querySelector('.product-page__zoom-close');
      if (closeButton) {
        closeButton.focus();
      }
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeZoom);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !zoomModal.hidden) {
        closeZoom();
      }
    });
  })();

  (() => {
    const modal = document.querySelector('[data-quote-modal]');
    const openButtons = document.querySelectorAll('[data-quote-open]');

    if (!modal || openButtons.length === 0) {
      return;
    }

    const closeButtons = modal.querySelectorAll('[data-quote-close]');
    const quantityInput = document.querySelector('.product-page__quantity input');
    const quoteQuantity = modal.querySelector('input[name="contact[Needed quantity]"]');
    const firstField = modal.querySelector('input:not([type="hidden"])');
    const successMessage = modal.querySelector('.product-page__quote-success');

    const openModal = () => {
      if (quantityInput && quoteQuantity) {
        quoteQuantity.value = quantityInput.value || quoteQuantity.value || 1;
      }

      modal.hidden = false;
      document.documentElement.classList.add('quote-modal-open');
      window.setTimeout(() => {
        if (successMessage) {
          successMessage.focus();
        } else if (firstField) {
          firstField.focus();
        }
      }, 0);
    };

    const closeModal = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('quote-modal-open');
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', openModal);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    if (successMessage || window.location.search.includes('contact_posted=true')) {
      openModal();
    }
  })();

  (() => {
    const modal = document.querySelector('[data-notify-modal]');
    const openButtons = document.querySelectorAll('[data-notify-open]');

    if (!modal || openButtons.length === 0) {
      return;
    }

    const closeButtons = modal.querySelectorAll('[data-notify-close]');
    const firstField = modal.querySelector('input:not([type="hidden"])');
    const successMessage = modal.querySelector('.product-page__quote-success');

    const openModal = () => {
      modal.hidden = false;
      document.documentElement.classList.add('notify-modal-open');
      window.setTimeout(() => {
        if (successMessage) {
          successMessage.focus();
        } else if (firstField) {
          firstField.focus();
        }
      }, 0);
    };

    const closeModal = () => {
      modal.hidden = true;
      document.documentElement.classList.remove('notify-modal-open');
    };

    openButtons.forEach((button) => {
      button.addEventListener('click', openModal);
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    if (successMessage || window.location.search.includes('contact_posted=true')) {
      openModal();
    }
  })();

  document.addEventListener('click', function (event) {
    const minus = event.target.closest('[data-quantity-minus]');
    const plus = event.target.closest('[data-quantity-plus]');

    if (!minus && !plus) {
      return;
    }

    const quantity = event.target.closest('.product-page__quantity').querySelector('input');
    const currentValue = Number(quantity.value || 1);

    if (minus) {
      quantity.value = Math.max(1, currentValue - 1);
    }

    if (plus) {
      quantity.value = currentValue + 1;
    }
  });

  (() => {
    const variantInputs = document.querySelectorAll('.product-page__variant-options input[name="id"]');
    const unitQuantitySpec = document.querySelector('[data-spec-unit-quantity]');
    const price = document.querySelector('.product-page__price');
    const comparePrice = document.querySelector('.product-page__price-row s');
    const savings = document.querySelector('.product-page__savings');
    const status = document.querySelector('.product-page__meta span:last-child');
    const addButton = document.querySelector('.product-page__add');

    if (!variantInputs.length || !unitQuantitySpec) {
      return;
    }

    const updateSpecs = (input) => {
      if (input && input.dataset.unitQuantity) {
        unitQuantitySpec.textContent = input.dataset.unitQuantity;
      }

      if (price && input.dataset.variantPrice) {
        price.textContent = input.dataset.variantPrice;
      }

      if (comparePrice) {
        comparePrice.textContent = input.dataset.variantComparePrice || '';
        comparePrice.hidden = !input.dataset.variantComparePrice;
      }

      if (savings) {
        savings.textContent = input.dataset.variantSavings || '';
        savings.hidden = !input.dataset.variantSavings;
      }

      if (status) {
        const label = status.querySelector('strong');
        status.textContent = '';
        if (label) {
          status.append(label);
        }
        status.append(input.dataset.variantAvailable === 'true' ? ' In stock' : ' Sold out');
      }

      if (addButton) {
        const isAvailable = input.dataset.variantAvailable === 'true';
        addButton.disabled = !isAvailable;
        addButton.textContent = isAvailable ? 'Add to cart' : 'Sold out';
      }
    };

    variantInputs.forEach((input) => {
      input.addEventListener('change', () => updateSpecs(input));

      if (input.checked) {
        updateSpecs(input);
      }
    });
  })();

  (() => {
    const copyButton = document.querySelector('[data-save-delivery-zip]');

    if (!copyButton) {
      return;
    }

    copyButton.addEventListener('click', () => {
      const deliveryZip = document.querySelector('[id^="DeliveryZip-"]');
      const quoteZip = document.querySelector('[id^="QuoteZip-"]');
      const savedMessage = document.querySelector('[data-delivery-zip-saved]');

      if (deliveryZip && quoteZip && deliveryZip.value) {
        quoteZip.value = deliveryZip.value;
      }

      if (deliveryZip && deliveryZip.value) {
        localStorage.setItem('dealsclick:quote-zip', deliveryZip.value);
      }

      if (savedMessage) {
        savedMessage.hidden = false;
      }
    });
  })();

  (() => {
    const storageKey = 'dealsclick:recently-viewed';
    const productDataScript = document.querySelector('[data-current-product-json]');

    if (!productDataScript) {
      return;
    }

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    let currentProduct;

    try {
      currentProduct = JSON.parse(productDataScript.textContent || '{}');
    } catch (error) {
      return;
    }

    let recentProducts = [];

    try {
      recentProducts = JSON.parse(localStorage.getItem(storageKey) || '[]');
    } catch (error) {
      recentProducts = [];
    }

    const previousProducts = recentProducts
      .filter((item) => item && item.url && item.url !== currentProduct.url)
      .slice(0, 8);

    const section = document.querySelector('[data-recently-viewed]');
    const grid = document.querySelector('[data-recently-viewed-grid]');

    if (section && grid && previousProducts.length > 0) {
      grid.innerHTML = previousProducts
        .map((item) => {
          const imageMarkup = item.image
            ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">`
            : '<span class="product-related-card__placeholder" aria-hidden="true"></span>';

          return `
            <a class="product-related-card" href="${escapeHtml(item.url)}">
              <span class="product-related-card__media">
                <span class="product-related-card__image image">${imageMarkup}</span>
              </span>
              <span class="product-related-card__content">
                ${item.brand ? `<span class="product-related-card__vendor">${escapeHtml(item.brand)}</span>` : ''}
                <span class="product-related-card__title">${escapeHtml(item.title)}</span>
                <span class="product-related-card__price">${escapeHtml(item.price)}</span>
              </span>
            </a>
          `;
        })
        .join('');
      section.hidden = false;
    }

    if (currentProduct && currentProduct.url && currentProduct.title) {
      const nextProducts = [currentProduct, ...previousProducts].slice(0, 9);
      localStorage.setItem(storageKey, JSON.stringify(nextProducts));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const categorySections = document.querySelectorAll('[data-search-categories]');

    const escapeHtml = (value) =>
      String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    const loadCategorySection = async (section) => {
      const query = section.dataset.query;
      const limit = Number(section.dataset.limit || 8);
      const grid = section.querySelector('[data-search-category-grid]');

      if (!query || !grid) {
        return;
      }

      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'collection',
        'resources[limit]': String(limit),
        'resources[options][fields]': 'title'
      });

      try {
        const response = await fetch(`/search/suggest.json?${params.toString()}`, {
          headers: { Accept: 'application/json' }
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        const collections = data?.resources?.results?.collections || [];

        if (collections.length === 0) {
          return;
        }

        grid.innerHTML = collections
          .slice(0, limit)
          .map((collection) => {
            const fallbackLetters = String(collection.title || 'Category')
              .split(/\s+/)
              .filter(Boolean)
              .slice(0, 2)
              .map((word) => word.charAt(0))
              .join('')
              .toUpperCase();

            return `
              <a class="search-category-card" href="${escapeHtml(collection.url)}">
                <span class="search-category-card__media">
                  <span class="search-category-card__placeholder" aria-hidden="true">${escapeHtml(fallbackLetters)}</span>
                </span>
                <span class="search-category-card__content">
                  <span class="search-category-card__title">${escapeHtml(collection.title)}</span>
                  <span class="search-category-card__count">Category</span>
                </span>
              </a>
            `;
          })
          .join('');

        section.hidden = false;
      } catch (error) {
        section.hidden = true;
      }
    };

    const scheduleCategoryLoad = (section) => {
      const run = () => loadCategorySection(section);

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1800 });
        return;
      }

      window.setTimeout(run, 700);
    };

    categorySections.forEach(scheduleCategoryLoad);

    const fallbackFilterRoots = document.querySelectorAll('[data-search-fallback-filters]');
    const fallbackProducts = Array.from(document.querySelectorAll('[data-search-product]'));

    if (fallbackFilterRoots.length > 0 && fallbackProducts.length > 0) {
      const normalize = (value) => String(value || '').trim();
      const collectValues = (key) =>
        Array.from(
          fallbackProducts.reduce((values, product) => {
            const value = normalize(product.dataset[key]);

            if (value) {
              values.set(value.toLowerCase(), value);
            }

            return values;
          }, new Map()).values()
        ).sort((first, second) => first.localeCompare(second));

      const facets = [
        { key: 'searchCategory', label: 'Category', values: collectValues('searchCategory') },
        { key: 'searchBrand', label: 'Brand', values: collectValues('searchBrand') }
      ].filter((facet) => facet.values.length > 0);

      const renderFacet = (facet) => `
        <details class="search-filter" open>
          <summary>${escapeHtml(facet.label)}</summary>
          <div class="search-filter__values">
            ${facet.values
              .map(
                (value) => `
                  <label class="search-filter__value">
                    <input type="checkbox" value="${escapeHtml(value)}" data-fallback-filter="${escapeHtml(facet.key)}">
                    <span>${escapeHtml(value)}</span>
                    <span class="search-filter__count">${fallbackProducts.filter((product) => normalize(product.dataset[facet.key]) === value).length}</span>
                  </label>
                `
              )
              .join('')}
          </div>
        </details>
      `;

      const clearMarkup = '<button class="search-filter__clear-button" type="button" data-search-clear-fallback>Clear filters</button>';
      const emptyMessage = document.createElement('div');
      emptyMessage.className = 'search-page__empty search-page__empty--filtered';
      emptyMessage.hidden = true;
      emptyMessage.innerHTML = '<h2>No products match those filters</h2><p>Clear filters or try another search.</p>';
      fallbackProducts[0].closest('.search-results')?.after(emptyMessage);

      fallbackFilterRoots.forEach((root) => {
        root.innerHTML = facets.map(renderFacet).join('') + clearMarkup;
      });

      const getSelected = () => ({
        searchCategory: Array.from(document.querySelectorAll('[data-fallback-filter="searchCategory"]:checked')).map((input) => input.value),
        searchBrand: Array.from(document.querySelectorAll('[data-fallback-filter="searchBrand"]:checked')).map((input) => input.value)
      });

      const syncInputs = (changedInput) => {
        document
          .querySelectorAll(`[data-fallback-filter="${changedInput.dataset.fallbackFilter}"][value="${CSS.escape(changedInput.value)}"]`)
          .forEach((input) => {
            input.checked = changedInput.checked;
          });
      };

      const applyFallbackFilters = () => {
        const selected = getSelected();
        let visibleCount = 0;

        fallbackProducts.forEach((product) => {
          const categoryMatches =
            selected.searchCategory.length === 0 || selected.searchCategory.includes(normalize(product.dataset.searchCategory));
          const brandMatches =
            selected.searchBrand.length === 0 || selected.searchBrand.includes(normalize(product.dataset.searchBrand));
          const isVisible = categoryMatches && brandMatches;

          product.hidden = !isVisible;

          if (isVisible) {
            visibleCount += 1;
          }
        });

        emptyMessage.hidden = visibleCount > 0;
      };

      document.addEventListener('change', (event) => {
        if (event.target.matches('[data-fallback-filter]')) {
          syncInputs(event.target);
          applyFallbackFilters();
        }
      });

      document.addEventListener('click', (event) => {
        if (event.target.matches('[data-search-clear-fallback]')) {
          document.querySelectorAll('[data-fallback-filter]').forEach((input) => {
            input.checked = false;
          });
          applyFallbackFilters();
        }
      });

      document.addEventListener('submit', (event) => {
        if (event.target.querySelector('[data-search-fallback-filters]')) {
          event.preventDefault();
          applyFallbackFilters();
        }
      });
    }

    const updateSearchCardPrice = (card, option) => {
      const price = card.querySelector('[data-search-card-price]');
      const comparePrice = card.querySelector('[data-search-card-compare-price]');
      const savings = card.querySelector('[data-search-card-savings]');

      if (price && option.dataset.variantPrice) {
        price.textContent = option.dataset.variantPrice;
      }

      if (comparePrice) {
        comparePrice.textContent = option.dataset.variantComparePrice || '';
        comparePrice.hidden = !option.dataset.variantComparePrice;
      }

      if (savings) {
        savings.textContent = option.dataset.variantSavings || '';
        savings.hidden = !option.dataset.variantSavings;
      }
    };

    const selectSearchCardVariant = (card, option) => {
      const idInput = card.querySelector('.search-product-card__form input[name="id"]');
      const addButton = card.querySelector('.search-product-card__form button');
      const quoteButton = card.querySelector('[data-quote-add]');
      const wishlistButton = card.querySelector('.search-product-card__wishlist');
      const status = card.querySelector('.search-product-card__status');
      const isAvailable = option.dataset.variantAvailable === 'true';

      card.querySelectorAll('[data-search-card-variant]').forEach((item) => {
        item.classList.toggle('is-selected', item === option);
      });

      if (idInput) {
        idInput.value = option.dataset.variantId || idInput.value;
      }

      if (addButton) {
        addButton.disabled = !isAvailable;
        addButton.textContent = isAvailable ? 'Add to cart' : 'Sold out';
      }

      if (quoteButton) {
        quoteButton.dataset.productStoreSku = option.dataset.variantSku || quoteButton.dataset.productStoreSku || '';
        quoteButton.dataset.productUpc = option.dataset.variantUpc || quoteButton.dataset.productUpc || '';
        quoteButton.dataset.productVariantId = option.dataset.variantId || quoteButton.dataset.productVariantId || '';
        quoteButton.dataset.productVariantTitle = option.dataset.variantTitle || quoteButton.dataset.productVariantTitle || '';
      }

      if (wishlistButton) {
        wishlistButton.dataset.variant = option.dataset.variantId || wishlistButton.dataset.variant || '';
      }

      if (status) {
        status.textContent = isAvailable ? 'Ready to ship' : 'Currently unavailable';
      }

      updateSearchCardPrice(card, option);
    };

    document.addEventListener('mouseover', (event) => {
      const option = event.target.closest('[data-search-card-variant]');

      if (!option) {
        return;
      }

      const card = option.closest('.search-product-card');

      if (card) {
        updateSearchCardPrice(card, option);
      }
    });

    document.addEventListener('focusin', (event) => {
      const option = event.target.closest('[data-search-card-variant]');

      if (!option) {
        return;
      }

      const card = option.closest('.search-product-card');

      if (card) {
        updateSearchCardPrice(card, option);
      }
    });

    document.addEventListener('mouseout', (event) => {
      const option = event.target.closest('[data-search-card-variant]');

      if (!option) {
        return;
      }

      const card = option.closest('.search-product-card');
      const selectedOption = card ? card.querySelector('[data-search-card-variant].is-selected') : null;

      if (card && selectedOption) {
        updateSearchCardPrice(card, selectedOption);
      }
    });

    document.addEventListener('click', (event) => {
      const option = event.target.closest('[data-search-card-variant]');

      if (!option) {
        return;
      }

      const card = option.closest('.search-product-card');

      if (card) {
        selectSearchCardVariant(card, option);
      }
    });

    const quickCart = document.querySelector('[data-search-quick-cart]');

    if (!quickCart) {
      return;
    }

    const mediaTarget = quickCart.querySelector('[data-search-quick-cart-media]');
    const titleTarget = quickCart.querySelector('[data-search-quick-cart-title]');
    const variantTarget = quickCart.querySelector('[data-search-quick-cart-variant]');
    const priceTarget = quickCart.querySelector('[data-search-quick-cart-price]');
    const countTarget = quickCart.querySelector('[data-search-quick-cart-count]');
    const totalTarget = quickCart.querySelector('[data-search-quick-cart-total]');
    const closeButtons = quickCart.querySelectorAll('[data-search-quick-cart-close]');
    let closeTimer;

    const moneyFormatter = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        currency: window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'USD',
        style: 'currency'
      }).format((cents || 0) / 100);

    const updateHeaderCartCount = (count) => {
      const cartLinks = document.querySelectorAll('a[href="/cart"]');

      cartLinks.forEach((link) => {
        let badge = link.querySelector('sup');

        if (count > 0) {
          if (!badge) {
            badge = document.createElement('sup');
            link.appendChild(badge);
          }

          badge.textContent = count;
          badge.hidden = false;
        } else if (badge) {
          badge.hidden = true;
        }
      });
    };

    const openQuickCart = (item, cart) => {
      window.clearTimeout(closeTimer);

      if (mediaTarget) {
        mediaTarget.innerHTML = item.image ? `<img src="${escapeHtml(item.image)}" alt="">` : '';
      }

      if (titleTarget) {
        titleTarget.textContent = item.product_title || item.title || 'Product';
      }

      if (variantTarget) {
        variantTarget.textContent = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        variantTarget.hidden = !variantTarget.textContent;
      }

      if (priceTarget) {
        priceTarget.textContent = `${item.quantity || 1} x ${moneyFormatter(item.final_price || item.price)}`;
      }

      if (countTarget) {
        countTarget.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'} in cart`;
      }

      if (totalTarget) {
        totalTarget.textContent = moneyFormatter(cart.total_price);
      }

      quickCart.hidden = false;
      quickCart.classList.add('is-open');
      updateHeaderCartCount(cart.item_count);

      closeTimer = window.setTimeout(() => {
        quickCart.classList.remove('is-open');
        quickCart.hidden = true;
      }, 6500);
    };

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        window.clearTimeout(closeTimer);
        quickCart.classList.remove('is-open');
        quickCart.hidden = true;
      });
    });

    document.addEventListener('submit', async (event) => {
      if (event.defaultPrevented) {
        return;
      }

      const form = event.target.closest('.search-product-card__form');

      if (!form) {
        return;
      }

      event.preventDefault();

      const button = form.querySelector('button[type="submit"]');
      const defaultText = button ? button.textContent : '';

      if (button) {
        button.disabled = true;
        button.textContent = 'Adding...';
      }

      try {
        const addResponse = await fetch('/cart/add.js', {
          body: new FormData(form),
          headers: {
            Accept: 'application/json'
          },
          method: 'POST'
        });

        if (!addResponse.ok) {
          throw new Error('Unable to add item');
        }

        const item = await addResponse.json();
        const cartResponse = await fetch('/cart.js', {
          headers: {
            Accept: 'application/json'
          }
        });
        const cart = await cartResponse.json();

        const cartDrawerEvent = new CustomEvent('dealsclick:cart-drawer-open', {
          detail: {
            cart,
            handled: false,
            notice: 'Product added to your cart.'
          }
        });
        window.dispatchEvent(cartDrawerEvent);

        if (!cartDrawerEvent.detail.handled) {
          openQuickCart(item, cart);
        }

        if (button) {
          button.textContent = 'Added';
          window.setTimeout(() => {
            button.disabled = false;
            button.textContent = defaultText || 'Add to cart';
          }, 1200);
        }
      } catch (error) {
        if (button) {
          button.disabled = false;
          button.textContent = 'Try again';
          window.setTimeout(() => {
            button.textContent = defaultText || 'Add to cart';
          }, 1800);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
